import React from "react";

export default function StatCard({ label, value, sub, accent = "text-black", testid }) {
  return (
    <div className="card-swiss p-5 min-w-0 overflow-hidden" data-testid={testid}>
      <div className="label-eyebrow truncate">{label}</div>
      <div
        className={`stat-num text-2xl sm:text-3xl mt-3 truncate ${accent}`}
        title={typeof value === "string" ? value : undefined}
      >
        {value}
      </div>
      {sub && <div className="text-xs text-gray-500 mt-2 truncate">{sub}</div>}
    </div>
  );
}
